import { useState } from 'react';
import './App.css';
import MusicPlayer from './Components/MusicPlayer';
import useSentimental from './Components/useSentimental';
import {Tweet} from "react-twitter-widgets"

function App() {
  const [text,setText]=useState(false)
  const {mood} = useSentimental(text)
  return (
    <div className="App">
      <nav>
        <h1 className="Riddim">Riddim Ai ⨯ ♪ </h1>
      </nav>
      <div className="container">
        <div>

          <div className="output">
            <h1 className="Riddim-Ai">Riddim Ai</h1>

            
            <p >

              {text[0]=="@" && <Tweet tweetId={text.slice(1,text.length)} options={{align:"center", height:"200px"}}/>}
              {!text && "• Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro, odio officiis ducimus iure aliquid commodi aperiam repellendus tenetur, ipsa totam vel, eius eveniet inventore laborum. Ipsa numquam enim molestiae! Aperiam!"}
              {text && text[0]!="@" && `• "${text}"`}
              
      </p>
      <span className="mood">
      {mood && `- ${mood}`}
      </span>
          </div>
          <div className="input">
            <input type="text" placeholder="@<Tweet : id> / write anything..."  onKeyDown={(e)=>{
              if(e.code=="Enter"){
                console.log("analysing sentiments...");
                setText(e.target.value)
              }
            }}/>
            <span>Try <strong> "How You feel?" </strong>,<strong> "How was your day?" </strong> or <a href="#">anything.</a></span>
          </div>

          <div className="musicplayer">
            <MusicPlayer mood={mood}/>
          </div>
        </div>

      
      </div>

    </div>
  );
}

export default App;
